import { formatYesNo } from "../../forms";

const formatPhones = (est) => {
  const phones = Array.isArray(est.phone_numbers)
    ? est.phone_numbers.filter(Boolean)
    : [est.phone_number_1, est.phone_number_2].filter(Boolean);
  return phones.length ? phones.join(", ") : "—";
};

const SavedProfileListView = ({ profile, accreditations, departments, specializationTypes }) => {
  if (!profile) return null;

  const accrLabels = (profile.accreditation_ids || "")
    .split(",")
    .map((id) => accreditations.find((a) => String(a.accreditation_id) === id.trim())?.accreditation_title)
    .filter(Boolean)
    .join(", ") || "—";

  const deptLabels = (profile.department_ids || "")
    .split(",")
    .map((id) => departments.find((d) => String(d.department_id) === id.trim())?.department_name)
    .filter(Boolean)
    .join(", ") || "—";

  const specLabels = (profile.specialization_type_ids || "")
    .split(",")
    .map((id) => specializationTypes.find((s) => String(s.specialization_type_id) === id.trim())?.specialization_type)
    .filter(Boolean)
    .join(", ") || "—";

  const rows = [
    { label: "Category", value: profile.category },
    { label: "Establishment Year", value: profile.establishment_year },
    { label: "Brand Name", value: profile.establishment_name },
    { label: "Legal Entity Name", value: profile.legal_entity_name },
    { label: "Establishment Type", value: profile.establishment_type || profile.establishment_type_display },
    { label: "Establishment Sub Type", value: profile.establishment_sub_type || profile.establishment_sub_type_display },
    { label: "Parent Entity", value: profile.parent_establishment_name || "None (Top-level)" },
    { label: "Registration Year", value: profile.registration_year },
    { label: "Registration Body", value: profile.registration_body },
    { label: "Accreditation", value: accrLabels },
    { label: "Country", value: profile.country_name },
    { label: "Location", value: profile.location_name },
    { label: "State / Province", value: profile.state_name },
    { label: "City", value: profile.city_name },
    { label: "Phone No", value: formatPhones(profile) },
    { label: "Email", value: profile.email_address },
    { label: "Website", value: profile.website_address },
    { label: "Address Line 1", value: profile.address },
    { label: "Address Line 2", value: profile.address_line_2 },
    { label: "Short Profile", value: profile.short_profile },
    { label: "Long Profile", value: profile.long_profile },
    { label: "Departments", value: deptLabels },
    { label: "Specialization", value: specLabels },
    { label: "Beds", value: profile.total_beds },
    { label: "Doctors", value: profile.total_doctors },
    { label: "OTs", value: profile.total_ots },
    { label: "ICU Beds", value: profile.total_critical_care_beds },
    { label: "Emergency / Trauma", value: formatYesNo(profile.emergency_dept_available) },
    { label: "Blood Bank", value: formatYesNo(profile.blood_bank_available) },
    { label: "NICU", value: formatYesNo(profile.nicu_available) },
    { label: "PICU", value: formatYesNo(profile.picu_available) },
    { label: "Facebook", value: profile.facebook_page },
    { label: "YouTube", value: profile.youtube_channel },
    { label: "Instagram", value: profile.instagram },
    { label: "LinkedIn", value: profile.linkedin },
    { label: "X / Twitter", value: profile.x_profile },
  ].filter((row) => row.value != null && row.value !== "" && row.value !== "—");

  if (rows.length === 0) return null;

  return (
    <div className="authdata-listview saved-profile-list">
      <h6 className="authdata-listview-title">Saved Profile Details</h6>
      <div className="authdata-table-scroll">
        <table className="authdata-table authdata-table--wide saved-profile-list__table">
          <thead>
            <tr>
              <th>#</th>
              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.label}>
                <td data-label="#">{i + 1}</td>
                <td data-label="Field">{row.label}</td>
                <td data-label="Value">{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SavedProfileListView;
